export const CHECK_NIUD_STATUS_ERROR_MESSAGES = {
  OrgIdNotFound: 'ארגון לא נמצא, אנא בדקו את הפרטים שהוזנו',
  GeneralError: 'מצטערים, משהו השתבש ולא ניתן לבצע את הפעולה שביקשת',
};

export const CHECK_NIUD_STATUS_TYPES = {
  NiudTime: 'NiudTime',
};

export const getCheckNiudStatusErrorMessage = (fallbackMessage) => {
  return fallbackMessage || CHECK_NIUD_STATUS_ERROR_MESSAGES.GeneralError;
};

export const formatRequestedPortTime = (requestedPortTime) => {
  if (!requestedPortTime) {
    return '';
  }

  const parsed = new Date(requestedPortTime);
  if (Number.isNaN(parsed.getTime())) {
    return requestedPortTime;
  }

  const day = String(parsed.getDate()).padStart(2, '0');
  const month = String(parsed.getMonth() + 1).padStart(2, '0');
  const year = parsed.getFullYear();
  const hours = String(parsed.getHours()).padStart(2, '0');
  const minutes = String(parsed.getMinutes()).padStart(2, '0');

  return `${day}.${month}.${year} ${hours}:${minutes}`;
};
